klevu.support.hook(["recs"],function(){
    // Modified function that adds Style tag to the head.
    function myAddElementStylesToHead (data, scope) {
        var recsKey = klevu.getObjectPath(scope.recsScope, "kmcData.metadata.recsKey");
        var elementStyles = klevu.getObjectPath(scope.recsScope, "kmcData.styles.base");
        if (recsKey) {
            klevu.each(klevu.dom.find("#ku-recs-" + recsKey), function (key, existingElement) {
                if (existingElement && existingElement.parentNode) {
                    existingElement.parentNode.removeChild(existingElement);
                }
            });
        }

        // Here we add a condition to only add the style tag if there is CSS.
        if (typeof elementStyles === 'string' && elementStyles.length) {
            klevu.dom.helpers.addElementToHead({
                content: elementStyles,
                type: "css",
                name: "ku-recs-" + recsKey
            });
        }
    }

    // Add an event to modify the existing recs events.
    klevu.recs.base.getScope().chains.response.success.addAfter('saveSettings', {
        name: "cleanupCSS",
        fire: function(data,scope){

            // Here we are replacing the two existing functions with our modified version above.
            scope.recsScope.chains.type.staticContent.add({
                name:"addElementStylesToHead",
                fire: myAddElementStylesToHead
            });
            scope.recsScope.chains.search.control.add({
                name:"addElementStylesToHead",
                fire: myAddElementStylesToHead
            });
        }
    });
});